import { render, staticRenderFns } from "./DichVuVanTaiKhachList.vue?vue&type=template&id=55c9c9c5"
import script from "./DichVuVanTaiKhachList.vue?vue&type=script&lang=js"
export * from "./DichVuVanTaiKhachList.vue?vue&type=script&lang=js"
import style0 from "./DichVuVanTaiKhachList.vue?vue&type=style&index=0&id=55c9c9c5&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports